import React from 'react';

const AuthorsPage: React.FC = () => {
  return (
    <div className="p-8 w-full">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Autorzy</h1>
      <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
        <p className="text-gray-600">Zarządzanie autorami - w trakcie implementacji</p>
      </div>
    </div>
  );
};

export default AuthorsPage;


